import { defineStore } from 'pinia';
import * as action from '@/lib/constants/manuscripts/store';

/**
 * Single-slot banner store. `activeTopHat` is either null or a
 * `{ type, values }` reference into the TOP_HAT_MESSAGES registry,
 * where `values` is an object keyed by the entry's declared urlParams.
 * The component looks up the registry entry by type at render time
 * and passes `values` to `entry.message(values)`. The store holds
 * no resolved strings or callbacks.
 */
const useProductBarTopHatStore = defineStore('manuscript-product-bar-top-hat', {
  state: () => ({
    activeTopHat: null,
  }),
  actions: {
    [action.SHOW_MANUSCRIPT_TOP_HAT]({ type, values = {} }) {
      if (!action.TOP_HAT_MESSAGES.has(type)) return;
      this.activeTopHat = {
        type,
        values: Object.fromEntries(
          Object.entries(values).map(([key, value]) => [key, String(value)]),
        ),
      };
    },
    [action.HIDE_MANUSCRIPT_TOP_HAT]() {
      this.activeTopHat = null;
    },
  },
});

export default useProductBarTopHatStore;
